import { EXPRESS_DELIVERY_TYPE } from "constants/ExpressConstants";
import { Address, ProductsDataTransform } from "./interface";
import AppConstants from "../../constants";
import DeliveryConstants from "../../constants/SharedConstants/DeliveryConstants";

import { displayUnitGrams, enumerateDaysBetweenDates, getUniqueValues, getValueFromArray, isUndefined, transformForScalable, transformIntoObj, transformIntoObjArrays } from "utils/helpers.utils";
import moment from "moment";
import { TextConstants } from "constants/TextConstants";

export const getActionItem = (deliveryInformation: any, status: any) => {
  switch (status) {
    case EXPRESS_DELIVERY_TYPE.UNASSIGNED:
      return TextConstants.ASSIGN;
    case EXPRESS_DELIVERY_TYPE.ASSIGNED:
      return TextConstants.REASSIGN;
    case EXPRESS_DELIVERY_TYPE.DELIVERY_ATTEMPTED:
    case EXPRESS_DELIVERY_TYPE.ON_HOLD:
      return deliveryInformation?.driver?.driverId
        ? TextConstants.REASSIGN
        : TextConstants.ASSIGN;
    default:
      return "";
  }
};

export const getAddressInfo = (addressObj: Address) => {
  return addressObj
    ? `${addressObj.building ? addressObj.building + ", " : ""}${
        addressObj.apartment ? addressObj.apartment + ", " : ""
      }${addressObj.zoneNumber ? addressObj.zoneNumber + ", " : ""}${
        addressObj.makani ? addressObj.makani + ", " : ""
      }${addressObj.streetNumber ? addressObj.streetNumber + ", " : ""}${
        addressObj.streetName ? addressObj.streetName + ", " : ""
      }${addressObj.area ? addressObj.area + ", " : ""}${
        addressObj.landmark ? addressObj.landmark + ", " : ""
      }${addressObj.zoneNumber ? addressObj.zoneNumber : ""}
  ${addressObj.city ? addressObj.city + ", " : ""}${
        addressObj.postalCode ? addressObj.postalCode + ", " : ""
      }${addressObj.countryIsoCode ? addressObj.countryIsoCode : ""}`
    : "";
};

export const getLatLong = (addressObj: Address) => {
  return addressObj
    ? `${
        addressObj.latitude
          ? parseFloat(addressObj.latitude).toFixed(5) + ", "
          : ""
      }${
        addressObj.longitude ? parseFloat(addressObj.longitude).toFixed(5) : ""
      }`
    : "";
};

export const getDropdownsData = (
  payload: any,
  codeKey?: string,
  valueKey?: string
) => {
  return payload.length
    ? payload.map((item: any) => {
        return {
          code: codeKey ? item[codeKey] : item.id,
          value: valueKey ? item[valueKey] : item.name,
        };
      })
    : [];
};

export const getConsignmentStatusField = (
  fieldName: string,
  statusCode: string
) => {
  const statuses: any =
    AppConstants.EXPRESS_CONSTANTS.CONSIGNMENTS_DATA.STATUSES;
  return statusCode && statuses[statusCode]
    ? statuses[statusCode][fieldName]
    : "";
};


export const getFilterAttributeValue = (attrValue: any, noKey?: boolean) => {
  let currentValue = noKey
    ? attrValue
    : attrValue.map((item: any) => item.value);
  const selectAllIdx = currentValue.indexOf(AppConstants.SELECT_ALL.value);
  const selectNoneIdx = currentValue.indexOf(AppConstants.SELECT_NONE.value);
  if (selectAllIdx > -1) {
    currentValue = [];
  }
  if (selectNoneIdx > -1) {
    currentValue = [];
  }
  return currentValue;
};

export const getConsignmentData = async (draftRouteData: any) => {
  const areas: any[] = [];
  let consignments: any[] = [];
  const slots: any = {};
  if (draftRouteData) {
    Object.keys(draftRouteData).forEach((statusKey: string) => {
      const statusValue: any = draftRouteData[statusKey];
      Object.keys(statusValue).forEach((areaKey: string) => {
        const areaIndex: number = areas.findIndex(
          (area: any) => area.code === areaKey
        );
        const area: any =
          areaIndex === -1
            ? {
                code: areaKey,
                value: areaKey,
                data: [],
              }
            : { ...areas[areaIndex] };
        const areaValue: any = statusValue[areaKey];
        Object.keys(areaValue).forEach((slotKey: string) => {
          const slotValue: any = areaValue[slotKey];
          const slotIndex: number =
            areaIndex !== -1
              ? area.data.findIndex((slot: any) => slot.code === slotKey)
              : -1;
          const slot: any =
            slotIndex === -1
              ? {
                  code: slotKey,
                  value: slotValue.slotValue,
                  area: areaKey,
                  data: [],
                }
              : { ...area.data[slotIndex] };
          const elements: any = slotValue.elements.map((consignment: any) => {
            return {
              code: consignment.id,
              value: consignment.id,
              data: consignment,
              slot: slotKey,
              slotValue: slotValue.slotValue,
              area: areaKey,
              status: statusKey,
            };
          });
          if (slotIndex !== -1) {
            slot.data = [...slot.data, ...elements];
            area.data[slotIndex] = slot;
          } else {
            slot.data = elements;
            area.data.push(slot);
          }
          if (slots[area.code]) {
            slots[area.code][slot.code] = slot.data;
          } else {
            slots[area.code] = {
              [slot.code]: slot.data,
            };
          }
          consignments = [...consignments, ...elements];
        });
        if (areaIndex !== -1) {
          areas[areaIndex] = area;
        } else {
          areas.push(area);
        }
      });
    });
  }
  return {
    areaWiseConsignments: areas,
    allConsignments: consignments,
    slotwiseConsignments: slots,
  };
};

export const rejectionDataTransform = (response: any) => {
  const transformedArray: any[] = [];
  response &&
    response.forEach((product: ProductsDataTransform) => {
      const { sku, entryNumber, rejectedQty, name, unitPrice } = product;
      let showReason = false;
      const qty = product.quantity;
      const isSubstitution = product.hasOwnProperty("substitutedProducts");

      const isScalable = isSubstitution
        ? product?.substitutedProducts?.length &&
          product.substitutedProducts[0].uom
          ? product.substitutedProducts[0].uom?.toLowerCase() === "grams"
          : product.uom?.toLowerCase() === "grams"
        : product.uom?.toLowerCase() === "grams";

      const totalQty = `${qty} ${
        product.uom && product.uom === "Grams"
          ? displayUnitGrams(product.uom)
          : ""
      }`;

      const rejectedItems = isSubstitution
        ? (product &&
            product.substitutedProducts &&
            product.substitutedProducts.length &&
            +product.substitutedProducts[0].rejectedQty) ||
          0
        : +product.rejectedQty || 0;

      const initialQty = isScalable
        ? rejectedItems > 0
          ? 1
          : 0
        : rejectedItems;

      const shipedQty =
        product.substitutedProducts && product.substitutedProducts.length
          ? product.substitutedProducts[0].shippedQty
          : product.shippedQty;

      const shipedQtyDisplay =
        product?.substitutedProducts && product?.substitutedProducts?.length
          ? Number(product.substitutedProducts[0].shippedQty) === 0
            ? 0
            : isScalable
            ? 1
            : product.substitutedProducts[0].shippedQty
          : product.shippedQty
          ? Number(product?.shippedQty) === 0
            ? 0
            : isScalable
            ? 1
            : product?.shippedQty
        : 0;

      let newObj: any = [];
      let selectRejected = [];
      if (isScalable) {
        for (let i = 0; i <= shipedQtyDisplay; i++) {
          newObj = transformForScalable(shipedQty, shipedQtyDisplay);
        }
      } else {
        for (let i = 0; i <= shipedQty; i++) {
          newObj = transformIntoObjArrays(i, shipedQty);
        }
      }

     
      selectRejected = transformIntoObj(initialQty);

      const deliveryReason: { name: string; value: string }[] = [];
      if (product.reason) {
        deliveryReason.push({
          name: product.reason.reasonDescription,
          value: product.reason.reasonCode,
        });
      } else {
        if (product.substitutedProducts) {
          product.substitutedProducts.forEach((subProd: any) => {
            if (subProd.reason) {
              deliveryReason.push({
                name: subProd.reason.reasonDescription,
                value: subProd.reason.reasonCode,
              });
            }
          });
        }
      }
      const uom = isSubstitution
        ? product?.substitutedProducts?.length &&
          product.substitutedProducts[0]?.uom
          ? product.substitutedProducts[0].uom?.toLowerCase() === "grams"
            ? displayUnitGrams(product.substitutedProducts[0].uom)
            : ""
          : product.uom?.toLowerCase() === "grams"
          ? displayUnitGrams(product.uom)
          : ""
        : product.uom?.toLowerCase() === "grams"
        ? displayUnitGrams(product.uom)
        : "";
      //Logic to showReason only when the rejectedQty is not zero
      if (rejectedQty !== "0" && !isUndefined(rejectedQty)) {
        showReason = true;
      }
      transformedArray.push({
        id: sku,
        name: name,
        entryNumber: entryNumber,
        shippedQty: shipedQty || 0,
        rejectedQty: rejectedQty || 0,
        unitPrice: unitPrice,
        totalQty: totalQty,
        rejectedQtyList: newObj,
        selectedRejectedQty: selectRejected,
        itemDeliveryReason: deliveryReason,
        substitutedProducts: product.substitutedProducts,
        virtualProducts: product.virtualProducts,
        showReason: showReason,
        error: "",
        uom: uom,
      });
    });
  return [...transformedArray];
};

export const sortedCountryData = (
  columnName: string,
  isDescending: boolean
) => (a: any, b: any) => {
  const aVal = isDescending ? a : b;
  const bVal = isDescending ? b : a;
  if (
    aVal[columnName].match(/^[0-9]+$/) &&
    bVal[columnName].match(/^[0-9]+$/)
  ) {
    return parseFloat(aVal[columnName]) - parseFloat(bVal[columnName]);
  } else {
    if (aVal[columnName] < bVal[columnName]) {
      return -1;
    } else if (aVal[columnName] > bVal[columnName]) {
      return 1;
    } else {
      return 0;
    }
  }
};

export const createDraftRoutePayload = (
  payload: any,
  flag?: { isSVT?: boolean; isCHD?: boolean}
) => {
  const routeId = sessionStorage.getItem("routeId");
  const consignments = JSON.parse(
    sessionStorage.getItem("extraConsignments") || "[]"
  );
  const responsePayload: any = {
    countryCode: sessionStorage.getItem(AppConstants.COUNTRY_CODE),
    hubCode: payload.hubCode,
    hubName: payload.hubName,
  };
  if (flag?.isSVT) responsePayload.isSVT = true;
  if (flag?.isCHD) responsePayload.isCHD = true;
  if (payload.isExpress) responsePayload.isExpress = true;
  if (payload.slotValue) {
    const dateRange: { startTime: string; endTime: string }[] = [];
    const selectAllIdx = payload.slotValue.indexOf(
      AppConstants.SELECT_ALL.value
    );
    const selectNoneIdx = payload.slotValue.indexOf(
      AppConstants.SELECT_NONE.value
    );
    if (payload.date) {
      const allDates = enumerateDaysBetweenDates(
        payload.date.startDate,
        payload.date.endDate
      );
      if (
        selectAllIdx > -1 ||
        selectNoneIdx > -1 ||
        !payload.slotValue.length
      ) {
        responsePayload.isDateRange = true;
        dateRange.push({
          startTime: moment(payload.date.startDate, AppConstants.DATE_FORMAT)
            .hours(0)
            .minutes(0)
            .seconds(0)
            .format(AppConstants.DATE_FORMAT_BACKEND),
          endTime: moment(payload.date.endDate, AppConstants.DATE_FORMAT)
            .hours(23)
            .minutes(59)
            .seconds(59)
            .format(AppConstants.DATE_FORMAT_BACKEND),
        });
      } else {
        responsePayload.isDateRange = false;
        payload.slotValue.forEach((slot: any) => {
          const splitSlot = slot.split("-");
          const startSlot = splitSlot[0].split(":");
          const endSlot = splitSlot[1].split(":");
          if (allDates.length) {
            allDates.forEach((date: string) => {
              dateRange.push({
                startTime: moment(date, AppConstants.DATE_FORMAT)
                  .hours(startSlot[0])
                  .minutes(startSlot[1])
                  .seconds(startSlot[2])
                  .format(AppConstants.DATE_FORMAT_BACKEND),
                endTime: moment(date, AppConstants.DATE_FORMAT)
                  .hours(endSlot[0])
                  .minutes(endSlot[1])
                  .seconds(endSlot[2])
                  .format(AppConstants.DATE_FORMAT_BACKEND),
              });
            });
          }
        });
      }
    }
    responsePayload.timeSlot = dateRange;
  }
  if (payload.zoneValue) {
    responsePayload.deliveryZones = getFilterAttributeValue(
      payload.zoneValue,
      true
    );
  }
  if (payload.editMode) {
    responsePayload.editMode = true;
  }
  if (payload.statusValue) {
    responsePayload.deliveryStatuses = getFilterAttributeValue(
      payload.statusValue,
      true
    );
  }
  if (routeId) {
    if (!payload.editMode) {
      if (consignments.length) {
        responsePayload.route = { id: routeId };
      }
    } else {
      responsePayload.route = { id: routeId };
    }
    if (consignments.length) {
      responsePayload.consignmentIds = consignments;
    }
    if (responsePayload?.route?.id && payload?.routeType) {
      responsePayload.route.routeType = payload.routeType;
    }
  }
  return responsePayload;
};

export const createConsignmentReplanningPayload = (params: any) => {
  const payload: any = {
    consignmentId: params.id,
  };
  if (
    params.status ===
    DeliveryConstants.CONSIGNMENTS_DATA.DEFAULT_REPLANNING_SELECTION
  ) {
    payload.reScheduled = true;
    const splitSlot = params.slot.split("-");
    const startSlot = splitSlot[0].split(":");
    const endSlot = splitSlot[1].split(":");
    payload.timeSlot = {
      startTime: moment(params.date.startDate, AppConstants.DATE_FORMAT_UI)
        .hours(startSlot[0])
        .minutes(startSlot[1])
        .seconds(startSlot[2])
        .format(AppConstants.DATE_FORMAT_BACKEND),
      endTime: moment(params.date.endDate, AppConstants.DATE_FORMAT_UI)
        .hours(endSlot[0])
        .minutes(endSlot[1])
        .seconds(endSlot[2])
        .format(AppConstants.DATE_FORMAT_BACKEND),
    };
  } else {
    payload.reScheduled = false;
    payload.status = params.selection;
    payload.comments = params.commentsValue;
    payload.reason = params.reason
      ? {
          reasonCode: params.reason.reasonCode,
          reasonDescription: params.reason.reasonDescription,
          deliveryStatus: params.reason.deliveryStatus,
          comment: params.comment || params.commentsValue,
        }
      : {};
     if (params.driverId) {
        payload.driverId = params.driverId;
      }
      if (params.helperId) {
           payload.helperId = params.helperId;
      }   
  }
  return payload;
};

export const calculateTransitTimeForConsignments = (
  directions: any,
  consignments: any
) => {
  const consignmentIdsTransitTime: any = {};
  if (directions.legs && directions.legs.length) {
    for (let i = 0; i < consignments.length; i++) {
      if (directions.legs[i]) {
        consignmentIdsTransitTime[consignments[i].code] =
          directions.legs[i].duration.value;
      } else {
        consignmentIdsTransitTime[consignments[i].code] = 0;
      }
    }
  }
  return consignmentIdsTransitTime;
};

export const getTotalCrates = (consignments: any[]) => {
  let totalCrates = 0;
  if (consignments.length) {
    consignments.forEach((item: any) => {
      if (item.data && item.data.deliveryInformation) {
        totalCrates += parseInt(item.data.deliveryInformation.totalCratesCount);
      }
    });
  }
  return totalCrates;
};

export const calculateTransitTime = (directions: any) => {
  let transitTime = 0;
  if (directions.legs && directions.legs.length) {
    directions.legs.forEach((leg: any) => {
      transitTime += leg.duration ? leg.duration.value : 0;
    });
    transitTime +=
      AppConstants.PLANNING_CONSTANTS.CREATE_ROUTE_DATA.DRIVER_SERVICE_TIME *
      directions.legs.length;
  }
  return transitTime;
};

export const createRouteCreationPayload = (payload: any) => {
  const isParentRoute = payload?.route.routeType === "PARENT_ROUTE";
  const transitTime: any = calculateTransitTimeForConsignments(
    payload.mapRouteDirections,
    payload.consignments
  );
  const routePayload: any = {
    countryCode: sessionStorage.getItem(AppConstants.COUNTRY_CODE),
    route: {
      id: payload.route.id,
      creationTime: payload.route.creationTime,
      createdBy: payload.route.createdBy,
      countryDetails: payload.route.countryDetails,
      hubCode: payload.route.hubCode,
      hubName: payload.route.hubName,
      deliveryArea: getUniqueValues(payload.consignments, "area"),
      deliverySlot: getUniqueValues(payload.consignments, "slot"),
      totalConsignment: payload.consignments.length,
      totalCrates: getTotalCrates(payload.consignments),
      deliveryDate: moment(payload.date, AppConstants.DATE_FORMAT)
        .hours(0)
        .minutes(0)
        .seconds(0)
        .format(AppConstants.DATE_FORMAT_BACKEND),
      plannedDate: payload.route.plannedDate,
      transitTime: payload.transitTime,
      consignmentsIds: isParentRoute
        ? payload?.route?.consignmentsIds
        : payload.consignments.map((item: any) => item.code),
    },
    consignmentTransitTime: transitTime,
  };
  if (payload.selectedDriver !== AppConstants.SELECT_NONE.value) {
    routePayload.route.assignee = {
      id: payload.selectedDriver,
    };
  }
  if (payload.selectedHelper !== AppConstants.SELECT_NONE.value) {
    routePayload.route.helper = {
      id: payload.selectedHelper,
    };
  }
  if (payload.selectedVehicle !== AppConstants.SELECT_NONE.value) {
    routePayload.route.assignedVehicle = {
      id: payload.selectedVehicle,
    };
  }
  return routePayload;
};

export const getCratesFromProducts = (items: any) => {
  const crates: any = [];
  items &&
    items.forEach((item: any) => {
      if (item.substitutedProducts && item.substitutedProducts.length) {
        item.substitutedProducts &&
          item.substitutedProducts
            .filter(({ shippedQty }: any) => {
              return +shippedQty > 0;
            })
            .forEach((element: any) => {
              if (element.associatedCrates) {
                const productCrates = element.associatedCrates;
                productCrates.forEach((crate: any) => {
                  const crateValue = getValueFromArray(
                    crates,
                    "crateId",
                    crate,
                    "crateId"
                  );
                  if (crateValue.length) {
                    const crateIndex = crates.findIndex(
                      (value: any) => value.crateId === crate.crateId
                    );
                    const newCrate = {
                      ...crate,
                      quantity: parseInt(crates[crateIndex].quantity) + 1,
                    };
                    crates.splice(crateIndex, 1, newCrate);
                  } else {
                    const newCrate = { ...crate, quantity: 1 };
                    crates.push(newCrate);
                  }
                });
              }
            });
      } else {
        if (item.shippedQty > 0 && item.associatedCrates) {
          const productCrates = item.associatedCrates;
          productCrates.forEach((crate: any) => {
            const crateValue = getValueFromArray(
              crates,
              "crateId",
              crate,
              "crateId"
            );
            if (crateValue.length) {
              const crateIndex = crates.findIndex(
                (value: any) => value.crateId === crate.crateId
              );
              const newCrate = {
                ...crate,
                quantity: parseInt(crates[crateIndex].quantity) + 1,
              };
              crates.splice(crateIndex, 1, newCrate);
            } else {
              const newCrate = { ...crate, quantity: 1 };
              crates.push(newCrate);
            }
          });
        }
      }
    });
  return crates;
};

export const createGetAllDropdownsPayload = (params: any) => {
  return {
    timeSlot: {
      startTime: moment(params.date.startDate, AppConstants.DATE_FORMAT)
        .hours(0)
        .minutes(0)
        .seconds(0)
        .format(AppConstants.DATE_FORMAT_BACKEND),
      endTime: moment(params.date.endDate, AppConstants.DATE_FORMAT)
        .hours(23)
        .minutes(59)
        .seconds(59)
        .format(AppConstants.DATE_FORMAT_BACKEND),
    },
    hubCode: params.hubCode,
    countryCode: sessionStorage.getItem(AppConstants.COUNTRY_CODE),
  };
};

/**
 * Returns a payload with timeSlot, countryCode, and hubCode.
 * @param params Object with date and hubCode properties.
 */
export function getTimeSlotPayload(params: { date: { startDate: string; endDate: string }; hubCode: string }) {
  return {
    timeSlot: {
      startTime: moment(params.date.startDate, AppConstants.DATE_FORMAT)
        .hours(0)
        .minutes(0)
        .seconds(0)
        .format(AppConstants.DATE_FORMAT_BACKEND),
      endTime: moment(params.date.endDate, AppConstants.DATE_FORMAT)
        .hours(23)
        .minutes(59)
        .seconds(59)
        .format(AppConstants.DATE_FORMAT_BACKEND),
    },
    countryCode: sessionStorage.getItem(AppConstants.COUNTRY_CODE),
    hubCode: params.hubCode,
  };
}
